// (B) message 어댑터 — antd message 파리티 커스텀 host 에 위임(sonner 미사용).
// 상태는 messageStore(realm 별 모듈 싱글톤)가 보유하고, OmMessageHost(KitThemeHost 마운트)가 렌더한다 →
// popup(EmailEditorWindow=별도 JS realm)과 main 이 자동 격리(per-realm bridge/injected 불필요).
//
// antd message 파리티: top-center, 작은 pill(아이콘+단문), 기본 3초, 새 메시지는 맨 아래에 append.
import type { ReactNode } from 'react'
import type { OmwMessageApi, OmwMessageOptions } from '../message/useMessage'
type OmMessageApi = OmwMessageApi
type OmMessageOptions = OmwMessageOptions
import { messageStore, type OmMessageKind } from './messageStore'

function show(kind: OmMessageKind, content: ReactNode, opts?: OmMessageOptions): void {
  messageStore.add(kind, content, { duration: opts?.duration })
}

const api: OmMessageApi = {
  success: (content, opts) => show('success', content, opts),
  error: (content, opts) => show('error', content, opts),
  info: (content, opts) => show('info', content, opts),
  warning: (content, opts) => show('warning', content, opts),
}

// React hook / 비React 싱글톤 동일(모듈 전역 store — App 컨텍스트 불필요).
export function useMessageImpl(): OmMessageApi {
  return api
}

export const omwMessage: OmwMessageApi = api
